import { Badge } from 'antd';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import { getSeverityColor } from '../../logic/store/Insights/InsightsModels';

interface ISingleRowContainerProps
{
	isDisabled?: boolean;
}

const SingleRowContainer = styled.div<ISingleRowContainerProps>`
	width: 100%;
	
	display: flex;
	flex-direction: row;
	
	margin-top: 12px;
	padding: 12px 16px;

	background-color: #fafafa;

	border: 1px solid #d9d9d9;
	border-radius: 2px;
	
	cursor: ${props => props.isDisabled ? 'default' : 'pointer'};
	color: ${props => props.isDisabled ? '#8c8c8c' : 'inherit'};

	&:first-child {
		margin-top: 2px;
	}
	`;

interface ISingleRowProps
{
	Id: string;
	Name: string;
	RelationshipTitle?: string | null;
	NumberOfItemsTitle: string;
	NumberOfItems: number;
	Severity?: string;
	SeverityCount?: number;

	/**
	 * When provided, the row is not selectable and shows this text in place of the item count.
	 * Used for rows there is nothing to drill into -- a territory with no analysed sales reps, say.
	 */
	DisabledMessage?: string;

	onSelect: (Id: string) => void;
}

export const SingleRow = (props: ISingleRowProps) =>
{
	const theme = useTheme();

	const { Id, Name, RelationshipTitle, NumberOfItems, NumberOfItemsTitle, Severity, SeverityCount, DisabledMessage, onSelect } = props;

	const isDisabled = !!DisabledMessage;

	return (
		<SingleRowContainer
			isDisabled={isDisabled}
			onClick={isDisabled ? undefined : () => onSelect(Id)}
		>
			<div style={{ fontWeight: theme.fontWeights.bold }}>
				{Name}
				{RelationshipTitle && <span style={{ fontWeight: theme.fontWeights.normal }}> ({RelationshipTitle})</span>}
			</div>
			{
				isDisabled
					? <div style={{ marginLeft: 'auto', fontStyle: 'italic' }}>{DisabledMessage}</div>
					: NumberOfItems > 0 &&
						<div style={{ marginLeft: 'auto' }}>{`${NumberOfItemsTitle}: ${NumberOfItems}`}</div>
			}
			{
				Severity &&
				<div style={{ display: 'flex', flexDirection: 'column', width: '5%', alignItems: 'flex-end', marginLeft: 'auto' }}>
					<Badge
						count={`${SeverityCount > 0 ? SeverityCount + ' ' : ''}${Severity.toUpperCase()}`}
						style={{
							backgroundColor: getSeverityColor(Severity),
							borderRadius: '4px',
							fontSize: '11px',
							fontWeight: theme.fontWeights.bold,
							padding: '0 8px',
							height: '20px',
							lineHeight: '20px'
						}} />
				</div>
			}
		</SingleRowContainer>
	);
};
